import { API_URL } from 'API/config';
import axios from 'axios';

export const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;

      let loginPage = '/';
      if (currentPath.startsWith('/student')) {
        loginPage = '/auth/login';
      } else if (currentPath.startsWith('/tutor')) {
        loginPage = '/auth/login';
      } else if (currentPath.startsWith('/admin')) {
        loginPage = '/admin/login';
      }

      // Preserve the full current URL (path + query string) so the login
      // page can redirect back to it after a successful authentication.
      const fullUrl = window.location.pathname + window.location.search;
      if (loginPage !== '/' && fullUrl !== '/') {
        window.location.href = `${loginPage}?redirect=${encodeURIComponent(
          fullUrl
        )}`;
      } else {
        window.location.href = loginPage;
      }
    }
    return Promise.reject(error);
  }
);
